"use strict";

var _classCallCheck = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _swan = require("@vp/swan");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Breadcrumbs = /*#__PURE__*/function (_React$Component) {
  _inherits(Breadcrumbs, _React$Component);

  var _super = _createSuper(Breadcrumbs);

  function Breadcrumbs() {
    _classCallCheck(this, Breadcrumbs);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumbs, [{
    key: "render",
    value: function render() {
      if (!this.props.data) {
        return React.createElement("div", null);
      }

      return React.createElement(React.Fragment, null, React.createElement(_reactHelmet.default, null, React.createElement("script", {
        type: "application/ld+json"
      }, this.getStructuredData())), React.createElement(_swan.Breadcrumbs, {
        "aria-label": "breadcrumbs"
      }, this.getBreadcrumbs()));
    }
  }, {
    key: "getBreadcrumbs",
    value: function getBreadcrumbs() {
      var _this = this;

      return this.props.data.map(function (piece, index) {
        // Only prefetch one level up for now. Can extend prefetching behavior here if desired
        var isParentBreadcrumb = index === _this.props.data.length - 2;
        var isLastBreadcrumb = piece.position === _this.props.data.length;
        return React.createElement(_swan.Breadcrumb, {
          key: piece.position
        }, !piece.available ? piece.name : React.createElement("a", _extends({
          href: piece.url
        }, isParentBreadcrumb && {
          "data-fidoprefetchhint": "IO"
        }, isLastBreadcrumb && {
          "aria-current": "page"
        }), piece.name));
      });
    }
  }, {
    key: "getStructuredData",
    value: function getStructuredData() {
      var items = this.props.data.map(function (piece) {
        return {
          "position": piece.position,
          "@type": "ListItem",
          "item": {
            "@id": "".concat(piece.url),
            "name": "".concat(piece.name)
          }
        };
      });
      return JSON.stringify({
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items
      });
    }
  }]);

  return Breadcrumbs;
}(React.Component);

exports.default = Breadcrumbs;